/** Hand-coins — Figma 5092:31303 (Mutual Funds), outer 32×32, leaf inset ~8.33% */
const HandCoinsIcon = ({ className }: { className?: string }) => (
    <span
        className={`relative inline-block size-8 shrink-0 overflow-hidden ${className ?? ""}`}
        aria-hidden
    >
        <span className="absolute inset-[8.33%_8.22%_8.33%_8.33%]">
            <span className="absolute inset-[-1.88%_-1.87%_-1.87%_-1.87%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 27.7025 27.6667"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.5 17.8333H15.1667C15.8739 17.8333 16.5522 17.5524 17.0523 17.0523C17.5524 16.5522 17.8333 15.8739 17.8333 15.1667C17.8333 14.4594 17.5524 13.7811 17.0523 13.281C16.5522 12.781 15.8739 12.5 15.1667 12.5H11.1667C10.3667 12.5 9.7 12.7667 9.3 13.3L1.83333 20.5M7.16667 25.8333L9.3 23.9667C9.7 23.4333 10.3667 23.1667 11.1667 23.1667H16.5C17.9667 23.1667 19.3 22.6333 20.2333 21.5667L26.3667 15.7C26.8812 15.2138 27.1815 14.5431 27.2015 13.8354C27.2215 13.1278 26.9596 12.4412 26.4733 11.9267C25.9871 11.4121 25.3164 11.1119 24.6088 11.0918C23.9011 11.0718 23.2145 11.3338 22.7 11.82L17.1 17.02M0.5 19.1667L8.5 27.1667M23.0333 9.83333C23.0333 11.9688 21.3022 13.7 19.1667 13.7C17.0312 13.7 15.3 11.9688 15.3 9.83333C15.3 7.69783 17.0312 5.96667 19.1667 5.96667C21.3022 5.96667 23.0333 7.69783 23.0333 9.83333ZM9.83333 4.5C9.83333 6.70914 8.04247 8.5 5.83333 8.5C3.62419 8.5 1.83333 6.70914 1.83333 4.5C1.83333 2.29086 3.62419 0.5 5.83333 0.5C8.04247 0.5 9.83333 2.29086 9.83333 4.5Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

export default HandCoinsIcon;
